import { render, staticRenderFns } from "./AreaDescription.vue?vue&type=template&id=2704014c"
import script from "./AreaDescription.vue?vue&type=script&lang=js"
export * from "./AreaDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports